/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [comment-entry.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 12.10.18 13:17
 */

import React, {useEffect, useRef, useState} from 'react';
import emojione from '../../../node_modules/emojione/lib/js/emojione';
import DOMPurify from "dompurify/dist/purify";
import {marked} from "marked";

import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import {formatFnsToNow} from "../configuration/configuration";

emojione.ascii = true;

const CommentText = ({comment}) => {
    const [status, setStatus] = useState(NONE_STATUS);
    const textRef = useRef(null);

    useEffect(() => {
        if(comment.text && textRef.current) {
            setStatus(PENDING_STATUS)
            const sanitized = DOMPurify.sanitize(
                marked(comment.text),
                {USE_PROFILES: {html: true}}
            );
            textRef.current.innerHTML = emojione.shortnameToImage(sanitized);
            setStatus(SUCCESS_STATUS);
        }
    }, []);

    if(status === PENDING_STATUS) return null;
    return <div className="comment-text">
        <div className='px-2' ref={textRef}/>
        <span className="comment-created">{formatFnsToNow(comment.created)}</span>
    </div>
}

export default CommentText;